var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluentEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.46 2.54008C16.9006 1.98133 16.1423 1.66748 15.3517 1.66748C14.561 1.66748 13.8027 1.98133 13.2433 2.54008L3.28334 12.5001C2.94463 12.8384 2.7066 13.2643 2.59584 13.7301L1.68334 17.5651C1.65864 17.669 1.66095 17.7774 1.69007 17.8801C1.71919 17.9829 1.77414 18.0764 1.84968 18.1519C1.92523 18.2273 2.01884 18.2822 2.1216 18.3112C2.22436 18.3402 2.33283 18.3424 2.43668 18.3176L6.27084 17.4042C6.73693 17.2936 7.16308 17.0556 7.50168 16.7167L17.46 6.75841C18.0188 6.19902 18.3326 5.44072 18.3326 4.65008C18.3326 3.85944 18.0188 3.10113 17.46 2.54174M14.1267 3.42508C14.2875 3.26421 14.4785 3.1366 14.6887 3.04954C14.8989 2.96248 15.1242 2.91767 15.3517 2.91767C15.5792 2.91767 15.8045 2.96248 16.0146 3.04954C16.2248 3.1366 16.4158 3.26421 16.5767 3.42508C16.7375 3.58595 16.8652 3.77693 16.9522 3.98711C17.0393 4.1973 17.0841 4.42257 17.0841 4.65008C17.0841 4.87758 17.0393 5.10286 16.9522 5.31304C16.8652 5.52323 16.7375 5.71421 16.5767 5.87508L15.8333 6.61591L13.3833 4.16674L14.1267 3.42508ZM12.5 5.05174L14.95 7.50008L6.61668 15.8334C6.44168 16.0084 6.22168 16.1309 5.98084 16.1884L3.13418 16.8667L3.81168 14.0201C3.86918 13.7784 3.99251 13.5584 4.16751 13.3834L12.5 5.05174Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentEdit);
export default __webpack_public_path__ + "static/media/fluent_edit.8b0cb9f1290ab1b1f7c86843f5541231.svg";
export { ForwardRef as ReactComponent };